import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import Icon from './Icon';
import { iconGetCachableAssets } from './iconAssetExtractor';

class IconBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  getComponent() {
    return Icon;
  }

  get type(): ComponentTypeUnionType {
    return 'Icon';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  getSlotOrder(_block: BlockType): { order: string[] } {
    return { order: ['tooltip'] };
  }

  // Delegates to the Node-importable sibling so the build-time
  // `cachableAssetExtractors` map can reach the same extractor without
  // loading this React-coupled class file.
  getCachableAssets(block: BlockType) {
    return iconGetCachableAssets(block);
  }
}

export default IconBlockStateDefinition;
